import React, { Component } from 'react';
import { string, func, number, shape, arrayOf } from 'prop-types';

import { inputPropTypes } from 'types/formTypes';

import UTRadioButton from './components/UTRadioButton';
import styles from './styles';

class UTFormRadioGroup extends Component {
  componentWillReceiveProps(nextProps) {
    if (
      this.props.selectedOptionName &&
      !nextProps.options.find(option => option.name === this.props.selectedOptionName)
    ) {
      this.props.input.onChange();
    }
  }

  render() {
    const { valueKey, labelKey } = this.props;
    return (
      <div name={this.props.name} style={styles.radioContainer}>
        {this.props.options.map(option => (
          <UTRadioButton
            key={option.id}
            label={option[labelKey]}
            onPress={() => this.props.input.onChange(option[valueKey])}
            selected={this.props.selectedOptionName === option[labelKey]}
          />
        ))}
      </div>
    );
  }
}

UTFormRadioGroup.propTypes = {
  options: arrayOf(
    shape({
      id: number.isRequired,
      name: string.isRequired
    }).isRequired
  ).isRequired,
  onChange: func.isRequired,
  selectedOptionName: string,
  name: string,
  labelKey: string,
  valueKey: string,
  input: inputPropTypes.isRequired
};

export default UTFormRadioGroup;
